/** @format */

import { Component } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"

import { CompanyService } from "src/app/services/company/company.service"
import { AuthService } from "src/app/services/auth/auth.service"
import { ErrorHandlerService } from "src/app/services/errorHandler/error-handler.service"
import { ToastService } from "src/app/services/toast/toast.service"

import constants from "src/app/constants"

@Component({
	standalone: false,
	selector: "app-add-super-user",
	templateUrl: "./add-super-user.component.html",
	styleUrls: ["./add-super-user.component.css"],
})
export class AddSuperUserComponent {
	selectedValues = {
		company: {
			companyId: 0,
			companyName: "dd",
		},
		plant: {
			plantId: 0,
			plantName: "dd",
		},
	}

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public toastService: ToastService,
		public userService: CompanyService,
		private authService: AuthService,
		private errorService: ErrorHandlerService,
	) {}

	addSuperUserRequest = {
		firstName: "",
		lastName: "",
		username: "",
		Roles: [] as string[],
	}

	errorMessage: any = {
		success: true,
		message: "",
	}

	currentRole: any

	firstRender = false
	searchText: String = ""

	nameRegex = /^[a-zA-Z0-9'\-\s]*$/
	showFirstNameError = false
	showLastNameError = false
	firstNameError = ""
	lastNameError = ""

	onFirstNameInput() {
		if (this.addSuperUserRequest.firstName.length > 0 && !this.nameRegex.test(this.addSuperUserRequest.firstName)) {
			this.firstNameError = "Only single quote ( ' ) and hyphen ( - ) are allowed as special characters"
			this.showFirstNameError = true
		} else {
			this.showFirstNameError = false
		}
	}

	onLastNameInput() {
		if (this.addSuperUserRequest.lastName.length > 0 && !this.nameRegex.test(this.addSuperUserRequest.lastName)) {
			this.lastNameError = "Only single quote ( ' ) and hyphen ( - ) are allowed as special characters"
			this.showLastNameError = true
		} else {
			this.showLastNameError = false
		}
	}

	transferData(success: boolean = false) {
		this.firstRender = true
		this.router.navigateByUrl("settings/user", {
			state: {
				selectedValues: { ...this.selectedValues },
				firstRender: this.firstRender,
				prevPage: success ? constants.addSuperUser : null,
				success: success,
			},
		})
	}

	ngOnInit(): void {
		this.currentRole = localStorage.getItem("role")
		this.selectedValues = history.state
	}

	isActiveBtn() {
		if (
			this.addSuperUserRequest.firstName.length >= 2 &&
			this.addSuperUserRequest.lastName.length >= 2 &&
			this.addSuperUserRequest.username.length >= 10 &&
			this.nameRegex.test(this.addSuperUserRequest.firstName) &&
			this.nameRegex.test(this.addSuperUserRequest.lastName)
		) {
			return true
		}
		return false
	}

	addUser() {
		this.addSuperUserRequest.Roles.push('Super Admin')
		this.authService.createKeycloakUser(this.addSuperUserRequest).subscribe({
		    next: (response) => {
		this.transferData(true)
		this.toastService.showToast = true
		this.toastService.toastText = "User successfully added!"
		setTimeout(() => {
			this.toastService.showToast = false
		}, 5000)
		    },
		    error: (response) => {
		        this.errorService.handleError(response, 'Error creating a super user')
		    },
		})
	}
}
